import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderSlot as _renderSlot } from "vue"

const _hoisted_1 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "check-icon"
}
const _hoisted_2 = { class: "cursor-pointer text-center" }
const _hoisted_3 = ["name", "value"]

import { toRefs } from 'vue';
import { useField } from 'vee-validate';


export default /*@__PURE__*/_defineComponent({
  __name: 'CheckboxInput',
  props: {
	id: String,
	class: String,
	containerClass: String,
	name: String,
	defaultValue: Boolean,
},
  setup(__props) {

const props = __props;

// we are using toRefs to create reactive references to `name` and `value` props
// this is important because vee-validte needs to know if any of these props change
// https://vee-validate.logaretm.com/v4/guide/composition-api/caveats
const { name } = toRefs(props);
// eslint-disable-next-line vue/no-dupe-keys
const { handleChange, value } = useField(name);

const toggle = () => {
	handleChange(!value.value);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "checkbox-wrapper",
    onClick: toggle
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex items-center", props.containerClass])
    }, [
      _createElementVNode("span", {
        class: _normalizeClass(["checkbox-box", { checked: __props.defaultValue ? __props.defaultValue : _unref(value) === true }])
      }, [
        (__props.defaultValue ? __props.defaultValue : _unref(value) === true)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
              _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
            ]))]))
          : _createCommentVNode("", true)
      ], 2),
      _createElementVNode("span", _hoisted_2, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ], 2),
    _createElementVNode("input", {
      type: "hidden",
      name: _unref(name),
      value: __props.defaultValue ? __props.defaultValue : _unref(value)
    }, null, 8, _hoisted_3)
  ]))
}
}

})